import { ReactNode, Children } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

type CanvasProps = {
    collapsed: boolean
    children?: ReactNode
}

export const Canvas = observer(({ collapsed, children }: CanvasProps) => {
    return (
        <div className="flex-1 overflow-auto">
            {Children.count(children) > 0 && (
                <div
                    className={classNames('mt-3', {
                        'px-3': !collapsed,
                        'pl-1 pr-2': collapsed,
                    })}
                >
                    {children}
                </div>
            )}
        </div>
    )
})
